module.exports = __webpack_public_path__ + "static/work_BigBang_UAU-1c21265e56200a49af1b52eaaab84a6d.jpeg";